import ContentWrapper from "./Component/ContentWrapper";
import Modal from "components/Modal";
import { Typography } from "@mui/material";

function Support({ open, onClose }) {
  return (
    <Modal
      title={<Typography dir="rtl">راه های ارتباطی با ساناکش</Typography>}
      maxWidth="xs"
      open={open}
      onClose={onClose}
      dir="rtl"
    >
      <ContentWrapper />
    </Modal>
  );
}
export default Support;
